import React from 'react';
import { Grid, Divider, useWindowSize } from 'vindi-ds-components';
import Section from './section';

function SectionWithGridCustomerNew({
  children,
  title,
  form,
  subtitle,
  values,
}) {
  const { isMobile } = useWindowSize();

  if (form) {
    const Form = form;
    return (
      <Section title={title} subtitle={subtitle}>
        <Form values={values} />
        {(isMobile) ? <Divider spacing='xxs' /> : <></>}
      </Section>
    );
  }

  return (
    <Section title={title} subtitle={subtitle}>
      <Grid container spacing={3}>
        {children}
      </Grid>
      {(isMobile) ? <Divider spacing='xxs' /> : <></>}
    </Section>
  );
}

export default SectionWithGridCustomerNew;
